import React from 'react';

export function DateColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `label label-lg label-inline`;
  };
  return <span className={getLabelCssClasses()}>{cellContent}</span>;
}
